var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex relative items-center bottom-4",
      class: _vm.ckickableClass,
    },
    [
      _c(
        "div",
        {
          staticClass: "flex-shrink-0 h-24 w-24",
          class: _vm.avatarOnly ? "tooltip" : "",
        },
        [
          _vm.image
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "h-28 w-28 border-2 rounded-full flex items-center justify-center",
                    class: _vm.customAvatarStyle,
                  },
                  [
                    _c("S3Image", {
                      staticClass:
                        "inline-block h-24 w-24 rounded-full object-cover object-center z-10",
                      class: _vm.customAvatarWidth,
                      attrs: { s3FileKey: _vm.image },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "h-28 w-28 border-2 rounded-full flex items-center justify-center",
                    class: _vm.customAvatarStyle,
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "inline-flex items-center bg-primary-500 justify-center h-24 w-24 rounded-full",
                        class: _vm.customAvatarWidth,
                      },
                      [
                        _c("span", { staticClass: "text-xl leading-none" }, [
                          _vm._v(_vm._s(_vm.initial)),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
          _vm.avatarOnly
            ? [
                _c("span", { staticClass: "tooltiptext bg-primary-500" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " "),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      [
        !_vm.avatarOnly
          ? _c("div", { staticClass: "ml-2" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.title,
                      expression: "title",
                    },
                  ],
                  staticClass: "leading-5",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.subtitle,
                      expression: "subtitle",
                    },
                  ],
                  staticClass: "text-sm leading-5 text-gray-500",
                },
                [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
              ),
            ])
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }